import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import { IPageV2 } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/IPageV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { NewCustomerDTO } from "@/models/customers/NewCustomerDTO";
import { PendingCompanyPrefillDTO } from "@/models/customers/PendingCompanyPrefillDTO";
import { CustomerManagementFilters } from "@/services/CustomerManagementFilters";
import { CustomerManagementDTO } from "@/types/CustomerManagementDTO";

class CustomerManagementService {
  path: string;
  constructor(path: string) {
    this.path = path;
  }

  getCustomers(page: number, pageSize: number): Promise<ApiResponseV2<IPageV2<CustomerManagementDTO>>> {
    return HttpClientV2.get(`${this.path}?page=${page}&pageSize=${pageSize}`);
  }

  search(term: string, page: number, pageSize: number): Promise<ApiResponseV2<IPageV2<CustomerManagementDTO>>> {
    return HttpClientV2.get(`${this.path}/search?term=${term}&page=${page}&pageSize=${pageSize}`);
  }

  filter(filters: CustomerManagementFilters, page: number, pageSize: number): Promise<ApiResponseV2<IPageV2<CustomerManagementDTO>>> {
    return HttpClientV2.post(`${this.path}/filter?page=${page}&pageSize=${pageSize}`, filters);
  }
  createCustomer(newCustomer: NewCustomerDTO): Promise<ApiResponseV2<CustomerManagementDTO>> {
    return HttpClientV2.post(`${this.path}/create-customer`, newCustomer);
  }

  getPendingCompanyPrefill(companyExternalId: string): Promise<ApiResponseV2<PendingCompanyPrefillDTO>> {
    return HttpClientV2.get(`${this.path}/pending-company/${companyExternalId}`);
  }
}

const customerManagementService = new CustomerManagementService("/api/customer-management");
export default customerManagementService;
